import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
// Local Deps
import './EntityDetails.scss';

export default class EntityDetails extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    currentFlow: PropTypes.string.isRequired,
    organization: PropTypes.string,
    continueWithoutRFQ: PropTypes.bool.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        left: PropTypes.any,
        right: PropTypes.any,
      }),
    ).isRequired,
  };

  static defaultProps = {
    className: '',
    organization: '',
  };

  static _createRows = items =>
    items.map((itm, idx) => {
      const { left, right } = itm;
      return (
        <tr className="nf-info-table__row" key={`nf-info-table-row-${idx}`}>
          <th className="nf-info-table__th" scope="row">
            {left}
          </th>
          <td className="nf-info-table__td">{right}</td>
        </tr>
      );
    });

  static _procGroup = (currentFlow, continueWithoutRFQ, organization) => {
    if (currentFlow === "gov") {
      return (
        <tr className="nf-info-table__row" key="procGroup">
          <th className="nf-info-table__th" scope="row">
            RFQ Group
          </th>
          <td className="nf-info-table__td">
            {continueWithoutRFQ ? "none" : organization}
          </td>
        </tr>
      );
    }
    return (<div />)
  }

  render() {
    const { className = '', items, currentFlow, continueWithoutRFQ, organization } = this.props;
    return (
      <Table className={`nf-info-table ${className}`} responsive bordered>
        <thead />
        <tbody>
          {EntityDetails._createRows(items)}

          {EntityDetails._procGroup(currentFlow, continueWithoutRFQ, organization)}
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/EntityDetailsForm/EntityDetails.jsx